import { RemoveProperty } from '../remove-property/remove-property';

export function RemoveAllIds(object: any): void {
  RemoveProperty(object, new Set(['id']));
}
